import { LinkNext } from 'components-v2/atoms/LinkNext/LinkNext';
import { cn } from 'lib/utils';

export interface IngredientProps {
  value?: {
    name: string;
    quantity: string;
    url?: string;
  }[];
  id?: string;
  title?: string;
}

export const Ingredient = ({ value, id, title }: IngredientProps) => {
  const isEmpty = !value || value.length === 0;

  // if (isEmpty) return null;

  return (
    <div id={id} className="border-[2px] border-[var(--primary-color)] rounded p-4 flex flex-col gap-2 bg-[#F5F5F5]">
      <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">{title}</h3>
      <ul className={cn('list-none p-0 pr-4 m-0 overflow-y-auto max-h-[220px] space-y-2', 'scrollbar-primary')}>
        {value?.map((item, index) => (
          <li key={index} className="flex justify-between items-center">
            <LinkNext href={item.url}>
              <span className='text-[var(--primary-color)]'>{item.name}</span>
            </LinkNext>
            <span>{item.quantity}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

